// src/components/ui/ModuleLoadingFallback.jsx
import Icon from '../AppIcon';
import PropTypes from 'prop-types';

/**
 * Enhanced loading fallback for lazy-loaded module pages
 * Provides a better UX with neumorphic design and module context
 */
const ModuleLoadingFallback = ({ moduleName = 'Module' }) => {
  return (
    <div className="min-h-screen flex items-center justify-center theme-bg-primary">
      <div className="text-center neumorphic-card p-12 rounded-2xl max-w-md">
        {/* Animated spinner */}
        <div className="relative w-20 h-20 mx-auto mb-6">
          <div className="absolute inset-0 border-4 theme-border rounded-full"></div>
          <div className="absolute inset-0 border-4 border-transparent border-t-blue-400 rounded-full animate-spin"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <Icon name="Shield" size={32} className="text-blue-400" />
          </div>
        </div>

        {/* Loading text */}
        <h2 className="text-xl font-bold theme-text-primary mb-2">Loading {moduleName}</h2>
        <p className="theme-text-secondary text-sm">
          Please wait while we prepare your workspace...
        </p>

        {/* Loading dots animation */}
        <div className="flex justify-center items-center space-x-2 mt-6">
          <div
            className="w-2 h-2 bg-blue-400 rounded-full animate-bounce"
            style={{ animationDelay: '0ms' }}
          ></div>
          <div
            className="w-2 h-2 bg-blue-400 rounded-full animate-bounce"
            style={{ animationDelay: '150ms' }}
          ></div>
          <div
            className="w-2 h-2 bg-blue-400 rounded-full animate-bounce"
            style={{ animationDelay: '300ms' }}
          ></div>
        </div>
      </div>
    </div>
  );
};

ModuleLoadingFallback.propTypes = {
  moduleName: PropTypes.string,
};

export default ModuleLoadingFallback;
